export const CategoryPills = ({ categories, active, onChange }) => {
  const all = [{ id: "all", name: "Todas" }, ...categories];
  return (
    <nav className="sticky top-0 z-30 backdrop-blur-md bg-[#120E0E]/85 border-b border-[#2E2323]" data-testid="category-nav">
      <div className="flex gap-2 overflow-x-auto no-scrollbar px-5 py-3 max-w-3xl mx-auto">
        {all.map((c) => (
          <button
            key={c.id}
            onClick={() => onChange(c.id)}
            data-testid={`category-pill-${c.id}`}
            className={`shrink-0 px-4 py-2 rounded-full text-sm font-semibold transition-[background-color,color,transform] duration-200 active:scale-95 ${
              active === c.id ? "bg-[#DC2626] text-white shadow-lg shadow-red-900/40" : "bg-[#1C1515] text-[#A89F91] border border-[#2E2323] hover:text-amber-100"
            }`}
          >
            {c.name}
          </button>
        ))}
      </div>
    </nav>
  );
};
